import { TowerService } from "../../api/service/tower.service";
import { isNullOrUndefined } from "util";
import { Router } from "@angular/router";
import { NavigationService } from "../../shared/navigation.service";
var LogsComponent = /** @class */ (function () {
    function LogsComponent(router, towerService, navigationService) {
        this.router = router;
        this.towerService = towerService;
        this.navigationService = navigationService;
    }
    LogsComponent.prototype.ngOnInit = function () {
        this.tableauAAfficher = false;
        var today = new Date();
        this.criteres = this.navigationService.getCriteres();
        if (isNullOrUndefined(this.criteres)) {
            this.criteres = {
                page: 1,
                beginYear: today.getFullYear(),
                beginMonth: today.getMonth() + 1,
                beginDay: today.getDate(),
                beginHour: today.getHours(),
                beginMinute: 0,
                endYear: today.getFullYear(),
                endMonth: today.getMonth() + 1,
                endDay: today.getDate(),
                endHour: today.getHours(),
                endMinute: 59
            };
        }
        this.years = new Array(today.getFullYear() - 2017);
        for (var i = 2018; i <= today.getFullYear(); i++) {
            this.years[i - 2018] = i;
        }
        this.months = new Array(12);
        for (var i = 1; i <= 12; i++) {
            this.months[i - 1] = i;
        }
        this.days = new Array(31);
        for (var i = 1; i <= 31; i++) {
            this.days[i - 1] = i;
        }
        this.hours = new Array(24);
        for (var i = 0; i <= 23; i++) {
            this.hours[i] = i;
        }
        this.minutes = new Array(60);
        for (var i = 0; i <= 59; i++) {
            this.minutes[i] = i;
        }
        this.domains = ['', 'activity', 'nosavions', 'cms', 'tower'];
        if (isNullOrUndefined(this.criteres.domain)) {
            this.applications = [''];
        }
        else {
            var appl = this.criteres.application;
            this.onChangeDomain(this.criteres.domain);
            if (!isNullOrUndefined(appl)) {
                this.criteres.application = appl;
            }
        }
        this.levels = ['', 'FATAL', 'ERROR', 'WARN', 'INFO', 'DEBUG'];
        this.environments = ['', 'production', 'test'];
        // this.cdref.detectChanges();
        this.lancerRecherche();
    };
    LogsComponent.prototype.onChangeDomain = function (domain) {
        if (domain === 'activity') {
            this.applications = ['', 'webapp'];
        }
        else if (domain === 'nosavions') {
            this.applications = ['', 'web', 'tactile', 'admin', 'widgets', 'gateway'];
        }
        else if (domain === 'cms') {
            this.applications = ['', 'web', 'admin', 'contact'];
        }
        else if (domain === 'tower') {
            this.applications = ['', 'api'];
        }
        this.criteres.application = '';
    };
    LogsComponent.prototype.levelStyle = function (level) {
        if (level === 'FATAL') {
            return { "background": "#ff3333" };
        }
        else if (level === 'ERROR') {
            return { "background": "#ff9933" };
        }
        else if (level === 'WARN') {
            return { "background": "#ffff66" };
        }
        else if (level === 'INFO') {
            return { "background": "#66ff66" };
        }
        else if (level === 'DEBUG') {
            return { "background": "#4db8ff" };
        }
        else {
            return null;
        }
    };
    LogsComponent.prototype.statusStyle = function (status) {
        if (isNullOrUndefined(status)) {
            return null;
        }
        else if (+status >= 500) {
            return { "background": "#ff3333" };
        }
        else if (+status >= 400) {
            return { "background": "#ff9933" };
        }
        else {
            return null;
        }
    };
    LogsComponent.prototype.rechercher = function () {
        this.criteres.page = 1;
        this.lancerRecherche();
    };
    LogsComponent.prototype.changerPage = function (page) {
        this.criteres = this.navigationService.getCriteres();
        this.criteres.page = page;
        this.lancerRecherche();
    };
    LogsComponent.prototype.lancerRecherche = function () {
        var _this = this;
        this.tableauAAfficher = false;
        this.navigationService.setCriteres(this.criteres);
        this.towerService.rechercherLogs(this.criteres).subscribe(function (resultat) {
            _this.resultats = resultat;
            if (!isNullOrUndefined(_this.resultats) && !isNullOrUndefined(_this.resultats.items)) {
                _this.tableauAAfficher = true;
            }
        }, function (error) {
            alert('Erreur durant la recherche');
        });
    };
    LogsComponent.prototype.selectItem = function (id) {
        this.router.navigate(['/logitem', id]);
    };
    return LogsComponent;
}());
export { LogsComponent };



// WEBPACK FOOTER //
// ./src/app/page/logs/logs.component.ts.pre-build-optimizer.js